// import './clock';
// import './carousel';
import './menu';
import './woo';
import './posts/loadmore';

// Styles
import '../sass/main.scss';

// Images
import '../img/patterns/bg.jpeg';
import '../img/patterns/c1-150x150.jpeg';
import '../img/patterns/c2-150x150.jpeg';
import '../img/patterns/c3-150x150.jpeg';
import '../img/email.webp';
import '../img/payment.webp';
import '../img/secure-with-macfee.webp';

jQuery(document).ready(function($){
  $('.rank-math-question').click(function(){
      $(this).toggleClass('plus-minus-icon');
      $(this).toggleClass('active').next('.rank-math-answer').slideToggle('fast');
      if ($(this).hasClass('active')) {
        $(this).find('.plus-minus-icon').text('-');
      } else {
        $(this).find('.plus-minus-icon').text('+');
      }
  });

  // Hide all term-description paragraphs except the first one
  $('.term-description p').not(':first').hide();

  // Create and append the View More button
  var $viewMoreButton = $('<button class="view-more btn btn-primary mt-2 mb-3 d-block mx-auto">View More</button>');
  $('.term-description').append($viewMoreButton);

  // Click event for the dynamically created View More/View Less button
  $('.term-description').on('click', '.view-more', function() {
  var buttonText = $(this).text();

  if (buttonText === 'View More') {
    // Show all term-description paragraphs
    $('.term-description p').slideDown();
    $(this).text('View Less');
  } else {
    // Hide all term-description paragraphs except the first one
    $('.term-description p').not(':first').slideUp();
    $(this).text('View More');
  }
  });

  /* Product category menu open when click on it - End */
  jQuery(".footer-widget .widget_nav_menu .widget-title").on("click", function () {
    jQuery(this).next().find("ul.menu").stop().slideToggle();
  });
});